module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10036.3d721df3.jpg";